module.exports = __webpack_public_path__ + "img/southeast-winter-1200x550.499e8ad9.jpg";